import { createContext } from "react";

import { ILiveMapContext } from "./hooks";

export const LiveMapContext = createContext<ILiveMapContext>({});
